module.exports = __webpack_public_path__ + "img/week_list_title_last.1952f874.png";